import { IBannerText } from '@/components/molecules/BannerText/BannerText';
import { localizedSlugs, routing } from '@/i18n/routing';
import { TLocale } from '@/types/global';
import { capitaliseEachWord } from '@/utils/generic';

export const generateServiceStructuredData = ({
  data,
  serviceSlug,
  locale,
}: {
  data: any;
  serviceSlug: string;
  locale: TLocale;
}) => {
  const urlLocale = locale === routing.defaultLocale ? '' : locale;
  const url = `${process.env.NEXT_PUBLIC_SITE_URL}/${urlLocale ? `/${urlLocale}` : ''}/${localizedSlugs.services[locale]}/${serviceSlug}`;
  const firstBannerText: IBannerText = data?.components?.find(
    (component: any) => component.type === 'BannerText'
  )?.props;
  const description =
    firstBannerText.subtitle || (firstBannerText.title as string);
  const descriptionCleaned = description
    ? (description as string).replace(/<br(?:\s+data-mobile)?>/g, '')
    : '';
  const service = serviceSlug
    ? capitaliseEachWord(serviceSlug.replace(/-/g, ' '))
    : '';

  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${service} | BergaGonzález`,
    url: url,
    description: descriptionCleaned,
    mainEntity: {
      '@type': 'Service',
      name: service,
      serviceType: service,
      provider: {
        '@type': 'Organization',
        name: 'BergaGonzález',
        url: process.env.NEXT_PUBLIC_SITE_URL,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+34 955 318 492',
          contactType: 'customer service',
          email: 'estudio@bergagonzalez.com',
        },
      },
      areaServed: {
        '@type': 'Place',
        name: 'Global',
      },
    },
  };
};
